// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-app-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 100%;
  background-color: rgb(68.7535714286, 59.8410714286, 82.7589285714);
  border-right: solid 1px rgba(0, 0, 0, 0.35);
  color: rgba(255, 255, 255, 0.95);
  font-weight: 400;
  z-index: 1001;
}
.simx-app-sidebar.simx-hidden {
  display: none;
}

.simx-app-sidebar-block {
  position: relative;
}
.simx-app-sidebar-block:not(:last-of-type)::after {
  content: "";
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0.5px);
  bottom: 0;
  height: 1px;
  width: 200px;
  background: rgba(255, 255, 255, 0.05);
}
.simx-app-sidebar-block.simx-style--translucent-blur-background {
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  background-color: rgba(68.7535714286, 59.8410714286, 82.7589285714, 0.75);
}

.simx-app-sidebar--content-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: auto;
}

.simx-app-sidebar--logo-block {
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 1;
}
.simx-app-sidebar--logo-block .simx-home-link {
  display: block;
  margin-top: 25px;
  margin-bottom: 30px;
}
.simx-app-sidebar--logo-block .simx-logo {
  display: block;
  width: 120px;
  height: auto;
}

.simx-app-sidebar--institutions-block {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 0;
}

.simx-app-sidebar-institution-block {
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.4);
  display: flex;
  flex-direction: column;
  font-family: "Quicksand";
  gap: 5px;
  margin: 0 5px;
  padding: 10px 15px;
}
.simx-app-sidebar-institution-block.simx-style--callout {
  background-color: rgba(255, 255, 255, 0.05);
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--badge {
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
  color: rgb(68.7535714286, 59.8410714286, 82.7589285714);
  display: flex;
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  margin: 5px 0;
  padding: 4px;
  text-transform: uppercase;
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--badge.simx-style--urgent {
  background-color: rgb(229, 0, 44);
  color: rgba(255, 255, 255, 0.95);
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--badge a {
  color: inherit;
  text-align: center;
  text-decoration: none;
  width: 100%;
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--heading {
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  font-weight: 700;
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--attributes-block {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.simx-app-sidebar-institution-block .simx-app-sidebar-institution-block--attribute {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  text-transform: uppercase;
}

.simx-app-sidebar--primary-navigation-block {
  padding: 30px 0;
}

.simx-app-sidebar--user-navigation-block {
  flex-grow: 1;
  margin-bottom: 1px;
}
.simx-app-sidebar--user-navigation-block .simx-authenticated-user-name {
  font-family: "Quicksand";
  font-size: 18px;
  font-weight: 700;
  padding: 20px 20px;
}

.simx-sidebar-navigation-block .simx-navigation-item {
  border-radius: 4px;
  color: inherit;
  display: block;
  font-family: "Quicksand";
  font-size: 16px;
  text-decoration: none;
  margin: 1px 5px 0 5px;
  padding: 10px 15px;
  position: relative;
  transition: background 0.2s, padding 0.2s;
}
.simx-sidebar-navigation-block .simx-navigation-item::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 5px;
  transform: translateY(-50%);
  width: 5px;
  height: calc(100% - 10px);
  background: rgb(229, 0, 44);
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.2s;
}
.simx-sidebar-navigation-block .simx-navigation-item:hover, .simx-sidebar-navigation-block .simx-navigation-item:focus {
  background-color: rgba(255, 255, 255, 0.05);
  outline: none;
}
.simx-sidebar-navigation-block .simx-navigation-item:active {
  background-color: rgba(255, 255, 255, 0.15);
}
.simx-sidebar-navigation-block .simx-navigation-item.simx-active {
  background-color: rgba(255, 255, 255, 0.1);
  cursor: default;
  font-weight: 700;
  padding-left: 20px;
}
.simx-sidebar-navigation-block .simx-navigation-item.simx-active::before {
  opacity: 1;
}

.simx-app-user-navigation {
  padding-bottom: 20px;
}

.simx-app-sidebar--app-version-block {
  bottom: 0;
  display: flex;
  justify-content: center;
  padding: 20px 20px;
  position: sticky;
}

.simx-app-release-version {
  color: rgba(255, 255, 255, 0.4);
  font-family: "Quicksand";
  font-size: 14px;
  text-transform: uppercase;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/core/components/app-sidebar/app-sidebar.component.scss","webpack://./src/assets/styles/_layout.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_theme.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YCPoB;EDQpB,YAAA;EACA,kEEJ8B;EFK9B,2CAAA;EACA,gCEO8B;EFN9B,gBAAA;EACA,aAAA;AAJF;AAME;EACE,aAAA;AAJJ;;AAQA;EACE,kBAAA;AALF;AAQI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;AANN;AAUE;EACE,kCAAA;UAAA,0BAAA;EACA,yEAAA;AARJ;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AATF;AAWE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AATJ;AAYE;EACE,cAAA;EACA,YAAA;EACA,YAAA;AAVJ;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAXF;;AAcA;EACE,kBG/E4B;EHgF5B,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,wBIlFgB;EJmFhB,QAAA;EACA,aAAA;EACA,kBAAA;AAXF;AAaE;EACE,2CAAA;AAXJ;AAcE;EACE,2CAAA;EACA,mBAAA;EACA,uDExF4B;EFyF5B,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;AAZJ;AAcI;EACE,iCEvG0B;EFwG1B,gCEtF0B;AF0EhC;AAeI;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAbN;AAiBE;EACE,gCElG4B;EFmG5B,eAAA;EACA,gBAAA;AAfJ;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhBJ;AAmBE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,yBAAA;AAjBJ;;AAqBA;EACE,eAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,kBAAA;AAlBF;AAoBE;EACE,wBIjJc;EJkJd,eAAA;EACA,gBAAA;EACA,kBAAA;AAlBJ;;AAuBE;EACE,kBG3J0B;EH4J1B,cAAA;EACA,cAAA;EACA,wBI7Jc;EJ8Jd,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AApBJ;AAsBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,yBAAA;EACA,2BE5K0B;EF6K1B,kBAAA;EACA,UAAA;EACA,wBAAA;AApBN;AAuBI;EAEE,2CAAA;EACA,aAAA;AAtBN;AAyBI;EACE,2CAAA;AAvBN;AA0BI;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAxBN;AA0BM;EACE,UAAA;AAxBR;;AA8BA;EACE,oBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AA3BF;;AA8BA;EACE,+BAAA;EACA,wBIxNgB;EJyNhB,eAAA;EACA,yBAAA;EACA,UAAA;AA3BF","sourcesContent":["@use 'colors';\n@use 'fonts';\n@use 'layout';\n@use 'theme';\n\n.simx-app-sidebar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: layout.$simxAppSidebarWidth;\n  height: 100%;\n  background-color: colors.$simxColorDarkAccentMedium;\n  border-right: solid 1px rgba(0, 0, 0, 0.35);\n  color: colors.$simxColorTextInvert;\n  font-weight: 400;\n  z-index: 1001;\n\n  &.simx-hidden {\n    display: none;\n  }\n}\n\n.simx-app-sidebar-block {\n  position: relative;\n\n  &:not(:last-of-type) {\n    &::after {\n      content: '';\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 0.5px);\n      bottom: 0;\n      height: 1px;\n      width: (layout.$simxAppSidebarWidth - (layout.$simxAppSidebarGutter * 2));\n      background: rgba(255, 255, 255, 0.05);\n    }\n  }\n\n  &.simx-style--translucent-blur-background {\n    backdrop-filter: blur(8px);\n    background-color: rgba(colors.$simxColorDarkAccentMedium, 0.75);\n  }\n}\n\n.simx-app-sidebar--content-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-x: auto;\n}\n\n.simx-app-sidebar--logo-block {\n  display: flex;\n  justify-content: center;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n\n  .simx-home-link {\n    display: block;\n    margin-top: 25px;\n    margin-bottom: 30px;\n  }\n\n  .simx-logo {\n    display: block;\n    width: 120px;\n    height: auto;\n  }\n}\n\n.simx-app-sidebar--institutions-block {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  padding: 15px 0;\n}\n\n.simx-app-sidebar-institution-block {\n  border-radius: theme.$simxBorderRadiusDefault;\n  color: rgba(colors.$simxColorWhite, 0.4);\n  display: flex;\n  flex-direction: column;\n  font-family: fonts.$simxFontGraphic;\n  gap: 5px;\n  margin: 0 5px;\n  padding: 10px 15px;\n\n  &.simx-style--callout {\n    background-color: rgba(255, 255, 255, 0.05);\n  }\n\n  .simx-app-sidebar-institution-block--badge {\n    background-color: rgba(255, 255, 255, 0.75);\n    border-radius: 20px;\n    color: colors.$simxColorDarkAccentMedium;\n    display: flex;\n    font-size: 14px;\n    font-weight: 700;\n    justify-content: center;\n    margin: 5px 0;\n    padding: 4px;\n    text-transform: uppercase;\n\n    &.simx-style--urgent {\n      background-color: colors.$simxColorBrightAccent;\n      color: colors.$simxColorTextInvert;\n    }\n\n    a {\n      color: inherit;\n      text-align: center;\n      text-decoration: none;\n      width: 100%;\n    }\n  }\n\n  .simx-app-sidebar-institution-block--heading {\n    color: colors.$simxColorTextInvert;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .simx-app-sidebar-institution-block--attributes-block {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n  }\n\n  .simx-app-sidebar-institution-block--attribute {\n    display: flex;\n    font-size: 14px;\n    justify-content: space-between;\n    text-transform: uppercase;\n  }\n}\n\n.simx-app-sidebar--primary-navigation-block {\n  padding: 30px 0;\n}\n\n.simx-app-sidebar--user-navigation-block {\n  flex-grow: 1;\n  margin-bottom: 1px;\n\n  .simx-authenticated-user-name {\n    font-family: fonts.$simxFontGraphic;\n    font-size: 18px;\n    font-weight: 700;\n    padding: 20px layout.$simxAppSidebarGutter;\n  }\n}\n\n.simx-sidebar-navigation-block {\n  .simx-navigation-item {\n    border-radius: theme.$simxBorderRadiusDefault;\n    color: inherit;\n    display: block;\n    font-family: fonts.$simxFontGraphic;\n    font-size: 16px;\n    text-decoration: none;\n    margin: 1px 5px 0 5px;\n    padding: 10px 15px;\n    position: relative;\n    transition: background theme.$simxTransitionSpeedDefault,\n      padding theme.$simxTransitionSpeedDefault;\n    &::before {\n      content: '';\n      position: absolute;\n      top: 50%;\n      left: 5px;\n      transform: translateY(-50%);\n      width: 5px;\n      height: calc(100% - 10px);\n      background: colors.$simxColorBrightAccent;\n      border-radius: 4px;\n      opacity: 0;\n      transition: opacity theme.$simxTransitionSpeedDefault;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: rgba(255, 255, 255, 0.05);\n      outline: none;\n    }\n\n    &:active {\n      background-color: rgba(255, 255, 255, 0.15);\n    }\n\n    &.simx-active {\n      background-color: rgba(255, 255, 255, 0.10);\n      cursor: default;\n      font-weight: 700;\n      padding-left: 20px;\n\n      &::before {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.simx-app-user-navigation {\n  padding-bottom: 20px;\n}\n\n.simx-app-sidebar--app-version-block {\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  padding: 20px layout.$simxAppSidebarGutter;\n  position: sticky;\n}\n\n.simx-app-release-version {\n  color: rgba(colors.$simxColorWhite, 0.4);\n  font-family: fonts.$simxFontGraphic;\n  font-size: 14px;\n  text-transform: uppercase;\n  z-index: 1;\n}\n","$simxAppHeaderHeight: 50px;\n\n$simxAppSidebarWidth: 240px;\n$simxAppSidebarGutter: 20px;\n\n$simxContentContainerGutter: 30px;\n\n$simxAdministrationViewPanelHeaderHeight: 45px;\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n","$simxFontDefault: 'Open Sans';\n$simxFontGraphic: 'Quicksand';\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
